module.exports = __webpack_public_path__ + "static/media/logo.01da2ed9.png";